// extracted by mini-css-extract-plugin
export var accordionHeaderRootCustom = "Footer-module--accordionHeaderRootCustom--a14a3";
export var accordionTitleCustom = "Footer-module--accordionTitleCustom--7af4f";
export var link = "Footer-module--link--8352a";
export var root = "Footer-module--root--3de60";
export var show = "Footer-module--show--5ac32";